export const formatDateToYearMonth = (date: any) => {
  const year = date ? date.getFullYear() : null
  const month = date ? date.getMonth() + 1 : null
  return date ? `${year}-${month < 10 ? `0${month}` : month}` : null
}

export const convertToHours = (timestamp: any) => {
  const date = new Date(timestamp)
  let hours = date.getHours()
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours ? hours : 12
  const strHours = hours.toString().padStart(2, '0')
  return `${strHours}:${minutes} ${ampm}`
}

export const formatDateToDDMMYYYY = (dateInput: string | Date | null | undefined) => {
  if (dateInput == null || dateInput === '') return '—'
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString('en-GB')
}

export const formatDateTimeToDDMMYYYY = (
  dateInput: string | Date | null | undefined
) => {
  if (dateInput == null || dateInput === '') return '—'
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  })
}

// .replace(/\//g, '-')
